module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_500_750.339f6a1a.png";